<template>
  <v-text-field
    v-model="value"
    label="Alterar senha"
    :type="show ? 'text' : 'password'"
    :error-messages="errorMessages"
    :hint="hint"
    autocomplete="off"
  >
    <template #append>
      <v-icon @click.prevent="show = !show">
        mdi-eye
      </v-icon>
    </template>
  </v-text-field>
</template>

<script>
  export default {
    name: 'PasswordInput',
    props: {
      label: {
        type: String,
        default: '',
      },
      hint: {
        type: String,
        default: '',
      },
      errorMessages: {
        type: String,
        default: '',
      },
    },
    data: function () {
      return {
        value: '',
        show: false,
      }
    },
    watch: {
      value: function (val) {
        this.$emit('input', val)
      },
    },
  }
</script>
